import axios from '@/utils/request'

export default {
    // 2020-07-22
    findByPhone(params) {
        return axios.get('/users/find-by-phone', params);
    },
    // 2020-07-22
    login(params) {
        return axios.post('/users/login', params)
    },
    // 2021-06-03
    loginNew(params) {
        return axios.post('/users/login-new', params)
    },
    // 2020-07-24
    regist(params) {
        return axios.post('/users/regist', params);
    },
    // 2020-07-25
    findByUnionid(params) {
        return axios.get('/users/find-by-unionid', params);
    },
    // 2020-07-26
    updateName(id, params) {
        return axios.put('/users/' + id + '/update-name', params)
    },
    // 2020-07-26
    updatePassword(id, params) {
        return axios.put('/users/' + id + '/update-password', params)
    },
    // 2020-07-26
    findById(id) {
        return axios.get('/users/' + id)
    },
    // 2020-07-28
    search(params) {
        return axios.get('/users', params)
    },
    // 2020-07-28
    update(id, params) {
        return axios.put('/users/' + id, params)
    },
    // 2021-01-16
    updateActions(id, params) {
        return axios.put('/users/' + id + '/update-actions', params)
    },
    // 2021-01-16
    updateManageUsers(id, params) {
        return axios.put('/users/' + id + '/update-manage-users', params)
    },
    // 2020-07-28
    create(params) {
        return axios.post('/users', params);
    },
    // 2020-07-28
    invalid(id) {
        return axios.delete('/users/' + id + '/invalid')
    },
    // 2021-06-07
    recovery(id) {
        return axios.put('/users/' + id + '/recovery')
    },
    // 2020-07-28
    findByShopId(params) {
        return axios.get('/users/find-by-shop-id', params)
    },
    //   updateCommonOperation(id, params) {
    //     return axios.put('/users/' + id + '/update-common-operation', params)
    //   },

    // 2020-12-29
    updateInfo(id, params) {
        return axios.put('/users/' + id + '/update-info', params)
    },

    // 2020-08-04
    findByTenantId(id) {
        return axios.get('/users/find-by-tenant-id')
    },


}

